import { SiteReccePriorityEnum, SiteRecceStatusEnum } from '@api/enum';
import { ISiteReccee, ISiteRecceStatusCounter } from '@api/models/site-recce.model';
import { getResellerIdFromRedux } from '@utils/common';
import http from 'httpConfig/http';

export const getAllProjectSiteRecce = async (clientInstallationId: string, projectInstallationId: string) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/site-recce`
    );
    // const data = dummyProjectInstallations;

    return data as ISiteReccee[];
};
export const getAllSiteRecce = async () => {
    const { data } = await http.get(`${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/site-recce`);
    // const data = dummyProjectInstallations;

    return data as ISiteReccee[];
};

export const addSiteRecce = async (clientInstallationId: string, projectInstallationId: string, payload: any) => {
    const { data, status } = await http.post(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/site-recce`,
        payload
    );
    return { data, status };
};

export const getSiteRecceById = async (
    clientInstallationId: string,
    projectInstallationId: string,
    siteRecceId: string
) => {
    const { data } = await http.get(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/site-recce/${siteRecceId}`
    );

    return data as ISiteReccee;
};

export const updateSiteRecce = async (
    clientInstallationId: string,
    projectInstallationId: string,
    siteRecceId: string,
    payload: any
) => {
    const { data } = await http.put(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/site-recce/${siteRecceId}`,
        payload
    );
    return data as ISiteReccee;
};

export const updateFileSiteRecce = async (
    clientInstallationId: string,
    projectInstallationId: string,
    siteRecceId: string,
    payload: any
) => {
    const { data } = await http.put(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/site-recce/${siteRecceId}/files`,
        payload
    );
    return data as ISiteReccee;
};

export const removeFileSiteRecce = async (
    clientInstallationId: string,
    projectInstallationId: string,
    siteRecceId: string,
    fileId: string
) => {
    const { data } = await http.delete(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/site-recce/${siteRecceId}/files/${fileId}`
    );
    return data as ISiteReccee;
};

export const getSiteRecceCount = async () => {
    const { data } = await http.get(`${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/site-recce/count`);
    // const data = dummyProjectInstallations;

    return data as ISiteRecceStatusCounter;
};
// export const getSiteReccePendingCount = async () => {

//     return 10;
// };

export const getSiteRecceByStatus = async (status: any) => {
    const { data } = await http.get(
        `${import.meta.env.VITE_APP_API_URL}/${getResellerIdFromRedux()}/site-recce/?status=${status}`
    );
    // const data = dummyProjectInstallations;

    return data as ISiteReccee[];
};

export const updateSiteRecceRemarks = async (
    clientInstallationId: string,
    projectInstallationId: string,
    siteRecceId: string,
    payload: any
) => {
    const { data } = await http.put(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/site-recce/${siteRecceId}/remarks`,
        payload
    );
    return data as ISiteReccee;
};

export const deleteSiteRecceRemark = async (
    clientInstallationId: string,
    projectInstallationId: string,
    siteRecceId: string,
    remarkId: string
) => {
    const { data } = await http.delete(
        `${
            import.meta.env.VITE_APP_API_URL
        }/${getResellerIdFromRedux()}/client-installations/${clientInstallationId}/project-installations/${projectInstallationId}/site-recce/${siteRecceId}/remarks/${remarkId}`
    );
    return data as ISiteReccee;
};
